import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=0bba2e00&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=0bba2e00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba2e00",
  null
  
)

export default component.exports